import { jsx as _jsx } from "react/jsx-runtime";
import { UserActivities } from '@src/components/Activity/UserActivities/UserActivities';
import { AuditLog } from '@src/components/Admin/AuditLog/AuditLog';
import { AuthConfigs } from '@src/components/Admin/AuthConfigs';
import { ChildClients } from '@src/components/Admin/ChildClients/ChildClients';
import { ClientFieldsOfStudy } from '@src/components/Admin/ClientFieldsOfStudy';
import { ClientProgramLevels } from '@src/components/Admin/ClientProgramLevels';
import { Clients } from '@src/components/Admin/Clients';
import { Communications } from '@src/components/Admin/Communications/Communications';
import { Contents } from '@src/components/Admin/Contents';
import { Dashboard } from '@src/components/Admin/Dashboard';
import { EmployeeNotifications } from '@src/components/Admin/EmployeeNotifications/EmployeeNotifications';
import { Employees } from '@src/components/Admin/Employees';
import { FieldsOfStudy } from '@src/components/Admin/FieldsOfStudy/FieldsOfStudy';
import { GradingScale } from '@src/components/Admin/GradingScale/GradingScales';
import { ImportRuns } from '@src/components/Admin/ImportRuns';
import { IntegrationTabs } from '@src/components/Admin/IntegrationTabs';
import { LocaleSettings } from '@src/components/Admin/LocaleSettings/LocaleSettings';
import { Macros } from '@src/components/Admin/Macros';
import { Metadata } from '@src/components/Admin/Metadata';
import { PayrollTabs } from '@src/components/Admin/PayrollTabs';
import { PolicyBuilder } from '@src/components/Admin/PolicyBuilder';
import { ProgramLevels } from '@src/components/Admin/ProgramLevels';
import { Reports } from '@src/components/Admin/Reports';
import { ReportTemplate } from '@src/components/Admin/ReportTemplate';
import { ReportTemplates } from '@src/components/Admin/ReportTemplates';
import { SchoolsList } from '@src/components/Admin/SchoolsList';
import { Users } from '@src/components/Admin/Users';
import { AuthRequired } from '@src/components/AuthRequired';
import { SubmitConfirmation } from '@src/components/Employee/EditProgram/SubmitConfirmation';
import { NewRequestStep1 } from '@src/components/Employee/NewRequest';
import { NewProgramIntro } from '@src/components/Employee/NewRequestIntro/NewProgramIntro';
import { ForgotPassword } from '@src/components/ForgotPassword';
import { Providers } from '@src/components/Providers';
import { ResetPassword } from '@src/components/ResetPassword';
import { SupportRequest } from '@src/components/SupportRequest';
import { EmployeeContextProvider } from '@src/contexts/EmployeeContextProvider';
import { AdminLayout } from '@src/layouts/AdminLayout';
import { LoginLayout } from '@src/layouts/LoginLayout';
import { AdminSchools } from '@src/pages/AdminSchools';
import { ApprovalTask } from '@src/pages/ApprovalTask';
import { ApprovalTasks } from '@src/pages/ApprovalTasks';
import { ClaimsList } from '@src/pages/ClaimsList';
import { Content } from '@src/pages/Content';
import { ActivityPage } from '@src/pages/Employee/ActivityPage';
import { NewPaymentRequest, PaymentRequestPage } from '@src/pages/Employee/PaymentRequests';
import { EditRequest as EditPaymentRequest } from '@src/pages/Employee/PaymentRequests/EditRequest';
import { SelectPaymentRequest } from '@src/pages/Employee/PaymentRequests/SelectPaymentRequest/SelectPaymentRequest';
import { NewProgram } from '@src/pages/Employee/Programs';
import { Program } from '@src/pages/Employee/Programs/Program';
import { ReimbursementPolicy } from '@src/pages/Employee/ReimbursementPolicy';
import { SiteMap } from '@src/pages/Employee/SiteMap';
import { Error } from '@src/pages/Error';
import { ExceptionRequest } from '@src/pages/ExceptionRequest';
import { ExceptionRequestsList } from '@src/pages/ExceptionRequestsList';
import { Export } from '@src/pages/Export';
import { Home } from '@src/pages/Home';
import { Import } from '@src/pages/Import';
import { Login } from '@src/pages/Login';
import { Macro } from '@src/pages/Macro';
import { PaymentRequestClaim } from '@src/pages/PaymentRequestClaim';
import { Profile } from '@src/pages/Profile';
import { Report } from '@src/pages/Report';
import { SelectClient } from '@src/pages/SelectClient';
import { SsoError } from '@src/pages/Sso';
import { EMPLOYEE_PERMISSIONS } from '@src/utilities/permissions';
import { LoginActivityMonitor, USER_PERMISSIONS } from 'pe-core-frontend';
import { LogoutModal } from '@src/components/LogoutModal';
import { Navigate, Outlet } from 'react-router-dom';
import App from '../App';
export default [
    // SelectClient has its own layout, so it's outside the App wrapper
    {
        path: '/select-client',
        element: (_jsx(Providers, { children: _jsx(AuthRequired, { permissions: USER_PERMISSIONS, children: _jsx(LoginActivityMonitor, { LogoutModal: LogoutModal, children: _jsx(SelectClient, {}) }) }) })),
    },
    {
        path: '/',
        element: (_jsx(Providers, { children: _jsx(EmployeeContextProvider, { children: _jsx(App, {}) }) })),
        errorElement: (_jsx(Providers, { children: _jsx(Error, {}) })),
        children: [
            {
                path: '/',
                element: _jsx(Home, {}),
            },
            {
                path: '/payments',
                element: (_jsx(AuthRequired, { permissions: EMPLOYEE_PERMISSIONS, children: _jsx(Outlet, {}) })),
                children: [
                    {
                        path: 'new',
                        children: [
                            {
                                path: ':id',
                                children: [
                                    {
                                        path: 'choose',
                                        element: _jsx(SelectPaymentRequest, {}),
                                    },
                                    {
                                        path: '',
                                        element: _jsx(NewPaymentRequest, {}),
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: ':id',
                        children: [
                            { path: 'submitted', element: _jsx(SubmitConfirmation, { isPaymentRequest: true }) },
                            { path: 'edit', element: _jsx(EditPaymentRequest, {}) },
                            { path: '', element: _jsx(PaymentRequestPage, {}) },
                        ],
                    },
                ],
            },
            {
                path: '/activity',
                element: (_jsx(AuthRequired, { permissions: EMPLOYEE_PERMISSIONS, children: _jsx(ActivityPage, {}) })),
            },
            {
                path: '/reimbursement-policy',
                element: (_jsx(AuthRequired, { permissions: EMPLOYEE_PERMISSIONS, children: _jsx(ReimbursementPolicy, {}) })),
            },
            {
                path: '/policy',
                element: (_jsx(AuthRequired, { onlyClaimsProcessor: true, onlyMemberSupport: true, children: _jsx(ReimbursementPolicy, {}) })),
            },
            {
                path: '/programs',
                element: (_jsx(AuthRequired, { permissions: EMPLOYEE_PERMISSIONS, children: _jsx(Outlet, {}) })),
                children: [
                    {
                        path: 'new',
                        children: [
                            {
                                path: 'intro',
                                element: _jsx(NewProgramIntro, {}),
                            },
                            {
                                path: '',
                                element: _jsx(NewProgram, {}),
                            },
                        ],
                    },
                    {
                        path: ':id',
                        children: [
                            { path: 'submitted', element: _jsx(SubmitConfirmation, {}) },
                            { path: '', element: _jsx(Program, {}) },
                        ],
                    },
                ],
            },
            {
                path: '/requests',
                element: (_jsx(AuthRequired, { permissions: EMPLOYEE_PERMISSIONS, children: _jsx(Outlet, {}) })),
                children: [{ path: '', element: _jsx(NewRequestStep1, {}) }],
            },
            {
                path: '/tasks',
                element: (_jsx(AuthRequired, { onlyManager: true, children: _jsx(Outlet, {}) })),
                children: [
                    {
                        path: ':id',
                        element: _jsx(ApprovalTask, {}),
                    },
                    { path: '', element: _jsx(ApprovalTasks, {}) },
                ],
            },
            {
                path: '/profile',
                element: (_jsx(AuthRequired, { permissions: USER_PERMISSIONS, children: _jsx(Profile, {}) })),
            },
            {
                path: '/site-map',
                element: _jsx(SiteMap, {}),
            },
        ],
    },
    {
        path: '/sso',
        element: (_jsx(Providers, { children: _jsx(SsoError, {}) })),
    },
    {
        path: '/login',
        element: _jsx(Navigate, { to: '/auth/login' }),
    },
    {
        path: '/auth',
        element: (_jsx(Providers, { children: _jsx(LoginLayout, {}) })),
        children: [
            {
                path: 'login',
                element: _jsx(Login, {}),
            },
            {
                path: 'sign-up',
                element: _jsx(Login, { signUp: true }),
            },
            {
                path: 'forgot-password',
                element: _jsx(ForgotPassword, {}),
            },
            {
                path: 'reset-password',
                element: _jsx(ResetPassword, {}),
            },
            {
                path: 'set-password',
                element: _jsx(ResetPassword, {}),
            },
        ],
    },
    {
        path: '/admin/*',
        element: (_jsx(Providers, { children: _jsx(AdminLayout, {}) })),
        children: [
            {
                path: 'clients',
                children: [
                    {
                        path: ':clientId',
                        children: [
                            {
                                path: 'dashboard',
                                element: _jsx(Dashboard, {}),
                            },
                            {
                                path: 'activity',
                                element: _jsx(UserActivities, { allEmployees: true }),
                            },
                            {
                                path: 'reports',
                                element: _jsx(Reports, {}),
                            },
                            {
                                path: 'reports/:id',
                                element: _jsx(Report, {}),
                            },
                            {
                                path: 'metadata/:entityType?',
                                element: _jsx(Metadata, {}),
                            },
                            {
                                path: 'imports',
                                element: _jsx(ImportRuns, {}),
                            },
                            {
                                path: 'payroll/:tab?',
                                element: _jsx(PayrollTabs, {}),
                            },
                            {
                                path: 'employees',
                                children: [
                                    {
                                        path: ':employeeId/activity',
                                        element: _jsx(UserActivities, {}),
                                    },
                                    {
                                        path: ':employeeId/notifications',
                                        element: _jsx(EmployeeNotifications, {}),
                                    },
                                    {
                                        path: '',
                                        element: _jsx(Employees, {}),
                                    },
                                ],
                            },
                            {
                                path: 'policies/:tab?',
                                element: _jsx(PolicyBuilder, {}),
                            },
                            {
                                path: 'comms/:type?',
                                children: [
                                    { path: '', element: _jsx(Contents, {}) },
                                    {
                                        path: ':id',
                                        element: _jsx(Content, {}),
                                    },
                                ],
                            },
                            {
                                path: 'auth',
                                element: _jsx(AuthConfigs, {}),
                            },
                            {
                                path: 'locale',
                                element: _jsx(LocaleSettings, {}),
                            },
                            {
                                path: 'integrations/:tab?',
                                children: [
                                    {
                                        path: '',
                                        element: _jsx(IntegrationTabs, {}),
                                    },
                                    {
                                        path: 'imports/:id',
                                        element: _jsx(Import, {}),
                                    },
                                    {
                                        path: 'exports/:id',
                                        element: _jsx(Export, {}),
                                    },
                                    {
                                        path: 'report-templates/:id/:type?',
                                        element: _jsx(ReportTemplate, {}),
                                    },
                                ],
                            },
                            {
                                path: 'fields-of-study',
                                element: _jsx(ClientFieldsOfStudy, {}),
                            },
                            {
                                path: 'program-levels',
                                element: _jsx(ClientProgramLevels, {}),
                            },
                            {
                                path: 'report-templates',
                                element: _jsx(ReportTemplates, {}),
                            },
                            {
                                path: '',
                                element: _jsx(Navigate, { to: 'dashboard' }),
                            },
                            {
                                path: '*',
                                element: _jsx("div", { children: " Page Not Found " }),
                            },
                            {
                                path: 'audit_logs',
                                element: _jsx(AuditLog, {}),
                            },
                            {
                                path: 'users',
                                element: _jsx(Users, {}),
                            },
                            {
                                path: 'child-clients',
                                element: _jsx(ChildClients, {}),
                            },
                        ],
                    },
                    { path: '', element: _jsx(Clients, {}) },
                ],
            },
            {
                path: 'claims',
                children: [
                    {
                        path: 'payments/:id',
                        element: _jsx(PaymentRequestClaim, {}),
                    },
                    {
                        path: ':tab?',
                        element: _jsx(ClaimsList, {}),
                    },
                ],
            },
            {
                path: 'exceptions',
                children: [
                    {
                        path: 'requests/:id',
                        element: _jsx(ExceptionRequest, {}),
                    },
                    {
                        path: ':tab?',
                        element: _jsx(ExceptionRequestsList, {}),
                    },
                ],
            },
            {
                path: 'users',
                element: _jsx(Users, {}),
            },
            {
                path: 'employees',
                element: _jsx(Employees, { showClientPicker: true }),
            },
            {
                path: 'comms',
                children: [
                    {
                        path: ':tab?',
                        children: [
                            {
                                path: '',
                                element: _jsx(Communications, {}),
                            },
                            {
                                path: ':type/:id',
                                element: _jsx(Content, {}),
                            },
                        ],
                    },
                ],
            },
            {
                path: 'schools/country/:code',
                element: _jsx(SchoolsList, {}),
            },
            {
                path: 'schools/accreditation/:id',
                element: _jsx(SchoolsList, {}),
            },
            {
                path: 'schools/:tab?',
                element: _jsx(AdminSchools, {}),
            },
            {
                path: 'profile',
                element: _jsx(Profile, {}),
            },
            {
                path: 'fields-of-study',
                element: _jsx(FieldsOfStudy, {}),
            },
            {
                path: 'program-levels',
                element: _jsx(ProgramLevels, {}),
            },
            {
                path: 'grading-scales',
                element: _jsx(GradingScale, {}),
            },
            {
                path: 'macros',
                children: [
                    {
                        path: ':id',
                        element: _jsx(Macro, {}),
                    },
                    {
                        path: '',
                        element: _jsx(Macros, {}),
                    },
                ],
            },
            {
                path: 'auth',
                element: _jsx(AuthConfigs, { isSystem: true }),
            },
            {
                path: '',
                element: _jsx(Navigate, { to: 'clients' }),
            },
        ],
    },
    {
        path: '/',
        element: (_jsx(Providers, { children: _jsx(LoginLayout, {}) })),
        children: [
            {
                path: 'support',
                element: _jsx(SupportRequest, {}),
            },
        ],
    },
    {
        path: '/not-found',
        element: (_jsx(Providers, { children: _jsx(Error, {}) })),
    },
];
